module.exports = {"TXTCLI_Code":{"id":"TXTCLI_Code","defaultMessage":"Код","track":"Code"}}